function eventConflictMessage(event, translationList) {
  const name = event?.length > 0 ? event[0]?.event?.name : "unknown";
  console.log(event[0])
  console.log("--->", name);

  return translationList.alreadyAssignedEvent.replace("{eventName}", name);
}
export default eventConflictMessage;
export { eventConflictMessage };
